import Search from "./components/Search";
import { AppBody } from "./assets/styles/App.styled.ts";

function App() {
  return (
    <AppBody>
      <Search/>
    </AppBody>
  );
}

export default App;

